import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"400px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"300px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"200px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "固定表示する回答を選択")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt20 centered" }, " 途中で質問を追加・変更・並び替えをした場合、表示されるフィールドの回答と異なる場合があります。 ", -1)
const _hoisted_8 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_9 = { class: "mt10" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "fl skyblue fs20 ml20",
  style: {"width":"30px","margin-top":"16px"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: /*#__PURE__*/_normalizeClass(`pointer fl mt15 ml10`),
  style: {"width":"calc(100% - 60px)"}
}
const _hoisted_15 = { class: "fs16 fw600" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "fs12 grey"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "決定", -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "QuestionsBoxModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.updateFields
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixScheduleModal && _ctx.hideFixScheduleModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (_f, fieldindex) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(`OnePossibleDate w100 hoverLightGrey pointer ${
                                _ctx.displayParamKeys.includes(_f.param_key) ? `selected` : ``
                            }`),
                  style: `min-height:65px;`,
                  key: `${fieldindex}`,
                  onClick: ($event: any) => (_ctx.selectField(_f))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`${_ctx.isSP ? `` : `fl`} arial dateFormatContent w100`),
                    style: {}
                  }, [
                    _createElementVNode("p", _hoisted_11, [
                      (_ctx.displayParamKeys.includes(_f.param_key))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "✔"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, " "))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_f.field_name), 1),
                      _hoisted_16,
                      (_f.param_key)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_f.param_key), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _hoisted_18
                ], 10, _hoisted_10))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("section", {
            id: "roomCloseButton",
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateQuestions && _ctx.updateQuestions(...args)))
          }, _hoisted_23)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}